module.exports = __webpack_public_path__ + "static/media/fishing-vest.589d424e.svg";